module.exports = __webpack_public_path__ + "left.3O6AS0_e.svg";